// @ts-ignore
import Logo from 'src/brand/assets/logo-1.webp'
// @ts-ignore
import LogoHighRes from 'src/brand/assets/boxyland.png'

export default {
    Logo,
    LogoHighRes
}
